import { ReactNode } from 'react'

import { CardSheetContentAction } from './CardSheetContentAction'
import { CardSubmitAction } from './CardSubmitAction'
import { CardUploadFilesAction } from './CardUploadFilesAction'
import { CardAction as CardActionConfig, CardData } from './types'

export function CardAction({
  action,
  data,
  children,
}: {
  action: CardActionConfig
  data: CardData
  children: ReactNode
}) {
  switch (action.type) {
    case 'submit':
      return (
        <CardSubmitAction action={action} data={data}>
          {children}
        </CardSubmitAction>
      )
    case 'sheet-content':
      return (
        <CardSheetContentAction action={action} data={data}>
          {children}
        </CardSheetContentAction>
      )
    case 'upload-files':
      return (
        <CardUploadFilesAction action={action} data={data}>
          {children}
        </CardUploadFilesAction>
      )
    default:
      return <>{children}</>
  }
}
